import { useAgreement, useConfirmAgreement } from "@/api/hooks/use-agreements";
import { useAgreementsStore } from "../store/agreements-store";
import useAuthStore from "@/store/use-auth-store";

/**
 * Hook for agreement confirmation modal
 * Handles current agreement display, confirmation, and decline (logout)
 */
export const useAgreementConfirmation = () => {
  const { pendingAgreements, currentAgreementIndex, nextAgreement } =
    useAgreementsStore();
  const { logout } = useAuthStore();

  // Get current agreement from queue
  const currentAgreement = pendingAgreements[currentAgreementIndex];

  // Fetch agreement details from API
  const {
    data: agreementData,
    isLoading,
    error: fetchError,
  } = useAgreement(currentAgreement?.name, {
    enabled: !!currentAgreement?.name,
  });

  // Confirm agreement mutation
  const { mutate: confirmAgreement, isPending } = useConfirmAgreement();

  // Handle agreement confirmation
  const handleConfirm = () => {
    if (!currentAgreement) return;

    confirmAgreement(currentAgreement.name, {
      onSuccess: () => {
        // Move to next agreement or close modal
        nextAgreement();
      },
    });
  };

  // Handle agreement decline (logout user)
  const handleDecline = () => {
    // Reset agreements store first
    const { reset } = useAgreementsStore.getState();
    reset();
    
    // Then logout
    logout();
  };

  return {
    // Data
    agreementData,
    currentAgreement,

    // States
    isLoading,
    isPending,
    fetchError,

    // Progress
    currentIndex: currentAgreementIndex,
    totalCount: pendingAgreements.length,

    // Actions
    handleConfirm,
    handleDecline,
  };
};

